// Utilitário para isolar estado client-side por tenant (subdomínio).
// Evita vazamento cross-tenant em abas/sessoes compartilhadas no mesmo navegador.

export function getTenantSlug() {
  try {
    const host = window.location.hostname || "";
    const parts = host.split(".");
    // Ex: pointdoaddad.usenucleo.com.br → "pointdoaddad"
    if (parts.length >= 3) {
      const sub = parts[0];
      if (!["www", "app", "api", "admin"].includes(sub)) return sub;
    }
    // Dev local com subdomínio *.localhost (ex: pointdoaddad.localhost → "pointdoaddad")
    if (parts.length === 2 && parts[1] === "localhost") {
      const sub = parts[0];
      if (!["www", "app", "api", "admin"].includes(sub)) return sub;
    }
    // Fallback local/dev
    return "default";
  } catch {
    return "default";
  }
}

// Prefixa chave de localStorage com slug. Chaves globais (ex: darkMode) passam null para nao prefixar.
export function scopedKey(key) {
  const slug = getTenantSlug();
  return `${slug}:${key}`;
}

export function scopedGetItem(key) {
  try {
    return localStorage.getItem(scopedKey(key));
  } catch {
    return null;
  }
}

export function scopedSetItem(key, value) {
  try {
    localStorage.setItem(scopedKey(key), value);
  } catch {}
}

export function scopedRemoveItem(key) {
  try {
    localStorage.removeItem(scopedKey(key));
  } catch {}
}

// Limpa todas as chaves localStorage do slug atual (usado no logout).
export function clearTenantStorage() {
  try {
    const prefix = `${getTenantSlug()}:`;
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) toRemove.push(k);
    }
    toRemove.forEach(k => localStorage.removeItem(k));
  } catch {}
}
